import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';

// import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  isLoggedIn$: Observable<boolean>;

  date = new Date().getFullYear();

  constructor(
    // private authService: AuthService
  ) {
  }

  ngOnInit() {
    // this.isLoggedIn$ = this.authService.isLoggedIn;
  }

}
